const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnowflakeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.5 43.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "snowflake_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\u0428\u0430\u0440_2",
    "data-name": "\u0428\u0430\u0440 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1",
    "data-name": "\u0421\u043B\u043E\u0439 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "0 21.5 38 21.5 48.5 21.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.33,
    y1: 14.5,
    x2: 38.17,
    y2: 21.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.33,
    y1: 28.66,
    x2: 38.17,
    y2: 21.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.65,
    y1: 28.66,
    x2: 10.81,
    y2: 21.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.65,
    y1: 14.5,
    x2: 10.81,
    y2: 21.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.94 0.83 31.03 33.09 36.58 42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.85,
    y1: 35.61,
    x2: 30.98,
    y2: 33.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.82,
    y1: 43.1,
    x2: 31.12,
    y2: 33.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.79,
    y1: 7.71,
    x2: 16.66,
    y2: 10.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.81,
    y1: 0.23,
    x2: 16.52,
    y2: 10.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "37.13 0.83 17.04 33.09 11.49 42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.22,
    y1: 35.61,
    x2: 17.09,
    y2: 33.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.24,
    y1: 43.1,
    x2: 16.95,
    y2: 33.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.28,
    y1: 7.71,
    x2: 31.41,
    y2: 10.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.26,
    y1: 0.23,
    x2: 31.55,
    y2: 10.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflakeWhite);
export default __webpack_public_path__ + "static/media/snowflake_white.94fe8e9023a7ead574a618c8bd6314d1.svg";
export { ForwardRef as ReactComponent };